import moment from 'moment'

export default {
	methods: 
    {	
		async updateDependiente()
		{
			this.active=0;
			const await1 = this.updateCrud({state: 'dataMultiple/'+this.namePath+'/multiple_servicios',data: this.predeterminados[this.namePath].multiple_servicios})
			const await2 = this.updateDataForm({state: 'info_afiliacion/id_list_tipo', data: 3})
			const await3 = this.updateDataForm({state: 'info_afiliacion/id_datos_razon', data: this.ultimaRazon})
			const await4 = this.updateDataForm({state: 'info_afiliacion/exonerado', data: 1})
			await await1
			await await2
			await await3
			await await4
		},
		async updateIndependiente()
		{
			this.active=1;
			const await1 =  this.updateCrud({state: 'dataMultiple/'+this.namePath+'/multiple_servicios',data: this.predeterminados[this.namePath].multiple_servicios})
			const await2 =  this.updateDataForm({state: 'info_afiliacion/id_list_tipo', data: 1})
			const await3 =  this.updateDataForm({state: 'info_afiliacion/id_datos_razon', data: 1})
			const await4 =  this.updateDataForm({state: 'info_afiliacion/exonerado', data: 0})
			await await1
			await await2
			await await3
			await await4
		},					
		changeNovedad()
		{
			
		},	
		async changeAporte()
		{
			await this.updateDataForm({state: 'info_afiliacion/id_list_novedad', data: 2})
			await this.updateDataForm({state: 'info_afiliacion/dias', data: 30})
			if(this.dataForm[this.namePath].info_afiliacion.mes_periodo.toString()===this.fecha(this.dataForm[this.namePath].info_afiliacion.ingreso).proximoPago.mes.toString() && this.dataForm[this.namePath].info_afiliacion.ano_periodo.toString()===this.fecha(this.dataForm[this.namePath].info_afiliacion.ingreso).proximoPago.ano.toString())
			{
				await this.updateDataForm({state: 'info_afiliacion/id_list_novedad', data: 1})
				let dias= moment(this.dataForm[this.namePath].info_afiliacion.ingreso).format('DD')!='Invalid date' ? moment(this.dataForm[this.namePath].info_afiliacion.ingreso).format('DD') : 1 
				if(dias>30)
				{
					dias=30
				}
				dias=31-dias
				await this.updateDataForm({state: 'info_afiliacion/dias', data: dias})
			}			
		},	
		invalidNovedad(invalid)
		{	
			try {
				if(invalid)
				{
					this.errorsAportes='Los campos en rojo son obligatorios.'
					return true
				}

				let ninguno='Debe asignar la entidad de: '
				let total=0
				for(let i=0;i<this.dataMultiple[this.namePath].multiple_servicios.length;i++)
				{
					if(this.dataMultiple[this.namePath].multiple_servicios[i].check===1 && (this.dataMultiple[this.namePath].multiple_servicios[i].name==='Eps' || this.dataMultiple[this.namePath].multiple_servicios[i].name==='Afp' || this.dataMultiple[this.namePath].multiple_servicios[i].name==='Ccf') && this.predeterminados[this.namePath].multiple_servicios[i].id_list.toString()===this.dataMultiple[this.namePath].multiple_servicios[i].id_list.toString())
					{			
						ninguno=ninguno+' *'+this.dataMultiple[this.namePath].multiple_servicios[i].name+' '
					}  
					if(this.dataMultiple[this.namePath].multiple_servicios[i].check===1 && (this.dataMultiple[this.namePath].multiple_servicios[i].name==='Riesgo' || this.dataMultiple[this.namePath].multiple_servicios[i].name==='Eps' || this.dataMultiple[this.namePath].multiple_servicios[i].name==='Afp' || this.dataMultiple[this.namePath].multiple_servicios[i].name==='Ccf'))
					{
						total=total+1
					} 
				}
				if(ninguno!=='Debe asignar la entidad de: ')
				{
					this.errorsAportes=ninguno
					return true
				}
				if(total===0)
				{
					this.errorsAportes='Debe seleccionar almenos un servicio'
					return true
				}
						
				ninguno= ''
				let yaexiste=_.filter(this.lists.datos_afiliado, ['documento',this.dataForm[this.namePath].datos_afiliado.documento])
				if(yaexiste.length>0)
				{			
					ninguno=ninguno+' El documento Nº '+yaexiste[0].documento+' pertenece al afiliado '+yaexiste[0].name+' y ya existe en el sistema.'
				}   
				
				if(ninguno!=='')
				{
					this.errorsAportes=ninguno
					return true
				}

					
				ninguno= ''
				for(let i=0;i<this.lists.datos_afiliado.length;i++)
				{
					if(this.lists.datos_afiliado[i].documento.toString()===this.dataForm[this.namePath].datos_afiliado.documento.toString() && this.lists.datos_afiliado[i].id_list_estado===1)
					{			
						ninguno=ninguno+' * El afiliado '+this.dataForm[this.namePath].datos_afiliado.name+' con documento '+this.dataForm[this.namePath].datos_afiliado.documento+' se encuentra activo en el sistema.'	
						i=10000							
					}   
				}
				if(ninguno!=='')
				{
					this.errorsAportes=ninguno
					return true
				}	

		
				let fechaHoy=this.fecha().fecha.minHoy
				let mesActual=parseInt(moment(fechaHoy).format('MM'))
				let anoActual=parseInt(moment(fechaHoy).format('YYYY'))


				let mesIngreso=parseInt(moment(this.dataForm[this.namePath].info_afiliacion.ingreso).format('MM'))
				let anoIngreso=parseInt(moment(this.dataForm[this.namePath].info_afiliacion.ingreso).format('YYYY'))
				

				if(mesActual!=mesIngreso || anoActual!=anoIngreso)
				{
					this.errorsAportes='El inicio de labores es direfente al mes actual'
					return false
				}
				
				this.errorsAportes=null
				return false
			}catch(e)
			{
				console.log(e)
			}
		},	
		async limpiarForm()
		{			
			await this.resetDataForm()
			await this.onInit()
			await this.resetDataIndex()
			await this.updateCrud({state: 'dataMultiple/'+this.namePath+'/multiple_servicios',data: this.predeterminados[this.namePath].multiple_servicios})
			
		},
	},
}